var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-hint__container"},[_c('img',{ref:"axe",staticClass:"bijl input-hint",attrs:{"alt":"axe","src":require("../../../assets/bijl.png")}}),_c('img',{ref:"twoTimes",staticClass:"verdubbelaar input-hint",attrs:{"alt":"verdubbelaar","src":require("../../../assets/img/exercises/verdubbelaar_dark.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }